<template lang="pug">
.refresh-token-holder(v-if="tokenExpired")
  BriqDialog.refresh-dialog(:hideCloseButton="false") 
    .p-20
      .auth-header
        .auth-header__logo
          svg.icon.icon-beeldmerk-large
            use(xlink:href="#icon-beeldmerk-large")
        .auth-header__text
          p Sign in to 
            span briq.app.
      BriqInput.mb-S(label="Domain" :value="maskWord(domain)" :hide-optional-marker="true" disabled)
      BriqInput.mb-S(label="Username" :value="maskWord(username)" :hide-optional-marker="true"  disabled)
      BriqInput.mb-S(
        label="Password" 
        v-model="password" 
        type="password" 
        placeholder="Password" 
        required 
        :error="passwordError"
        @blur="$v.password.$touch()"
      )
      .action-buttons
        BriqSubmitButton.login-btn(@click="refreshJwtToken()" variant="jumbo" :pending="pending") Login 
        BriqButton(@click="logoutUser()" jumbo variant="secondary") Cancel 
  .blur-background
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'RefreshApiTokenDialog',
  data() {
    return {
      domain: '',
      username: '',
      password: '',
      error: null,
      pending: false,
      tokenExpired: false,
    }
  },
  validations() {
    return {
      password: { required },
    }
  },
  watch: {
    tokenExpired(newval) {
      if (newval) {
        this.getDomainAndUserName()
        self.$bus.$emit('token-expired', newval)
      }
    },
  },
  computed: {
    canLogin() {
      return !this.$v.$error && !this.$v.$invalid
    },
    passwordError() {
      return this.$v.password.$error ? 'Password is required!' : null
    },
  },
  mounted() {
    this.checkIfTokenExpired()
  },
  methods: {
    async refreshJwtToken() {
      if (!this.canLogin) {
        this.$v.password.$touch()
        return false
      }
      this.pending = true
      try {
        const postModel = { domain: this.domain, username: this.username, password: this.password }
        const response = await this.$apiClient.post('auth-user/refresh-jwttoken', postModel)

        if (response.data.message === 'ERROR') {
          this.$notifyError(response.data.error_message)
          setTimeout(() => {
            window.location.href = '/login'
          }, 3000)
        } else {
          this.$notifySuccess('Session restored!')
          this.pending = false
          this.tokenExpired = false
        }
        this.checkIfTokenExpired()
      } catch (e) {
        this.error = e
        const message = 'There was a problem: ' + this.error.message
        this.$notifyError(message)
        this.pending = false
      }
    },
    logoutUser() {
      window.location.href = '/logout'
    },
    maskWord(word) {
      return typeof word !== 'undefined' ? `****${word.replace(/\w(?=\w{3})/g, '*')}` : ''
    },
    async getDomainAndUserName() {
      try {
        const response = await this.$apiClient.get('auth-user/domain-and-username')
        this.domain = response.data.domain
        this.username = response.data.username
      } catch (e) {
        this.error = e
        const message = 'There was a problem: ' + this.error.message
        this.$notifyError(message)
      }
    },
    checkIfTokenExpired() {
      this.checkIfTokenIsValidInterval = setInterval(
        async function() {
          try {
            const response = await this.$apiClient.get('auth-user/validate-jwttoken')
            if (response.data.tokenValid === null) window.location.href = '/login'
            if (!response.data.tokenValid) {
              this.tokenExpired = true
              clearInterval(this.checkIfTokenIsValidInterval)
            }
          } catch (e) {
            this.error = e
            const message = 'There was a problem: ' + this.error.message
            this.$notifyError(message)
          }
        }.bind(this),
        30000, //TODO: Use an environment variable
      )
    },
  },
}
</script>

<style scoped lang="stylus">
.p-20
  padding 20px

.action-buttons
  display flex

.login-btn
  margin-right 15px

.refresh-dialog
  z-index 1200

.blur-background
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  backdrop-filter blur(10px)
  z-index 1100
</style>
